(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["na-co-dzien-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ncd-product]').forEach((root) => {
    const main = root.querySelector('.ncd-main-media img');
    root.querySelectorAll('[data-ncd-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!main) return;
        main.src = button.dataset.src;
        main.srcset = '';
        main.alt = button.dataset.alt || '';
        root.querySelectorAll('[data-ncd-thumb]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncd-dessert-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ncd-sweet]').forEach((root) => {
    const form = root.querySelector('.ncd-sweet__buy');
    if (!form) return;
    const consents = Array.from(form.querySelectorAll('[data-ncd-sweet-consent]'));
    const button = form.querySelector('[data-ncd-sweet-buy]');
    const status = form.querySelector('[data-ncd-sweet-status]');
    const sync = () => { if (button) button.disabled = consents.some((input) => !input.checked); };
    consents.forEach((input) => input.addEventListener('change', sync));
    form.addEventListener('submit', async (event) => {
      event.preventDefault(); sync();
      if (!button || button.disabled) return;
      const label = button.querySelector('span'); const original = label?.textContent || '';
      button.disabled = true; if (label) label.textContent = 'Dodaję e-book…'; if (status) status.hidden = true;
      try {
        const rootPath = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error(response.status === 422 ? 'dessert-unavailable' : 'cart-add');
        window.location.assign(`${rootPath}cart`);
      } catch (error) {
        if (label) label.textContent = original;
        if (status) {
          status.textContent = error.message === 'dessert-unavailable'
            ? 'Nie udało się dodać e-booka. Odśwież stronę i spróbuj ponownie. Jeśli problem wróci, skontaktuj się z nami.'
            : 'Shopify nie przyjął produktu. Odśwież stronę i spróbuj ponownie.';
          status.hidden = false;
        }
        sync();
      }
    });
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncd-ebook-selector"] && !Shopify.designMode) return;
  try {
    
  const ncdOpenOfferDialog = (name) => {
    const dialog = document.querySelector('[data-ncd-offer-dialog="' + name + '"]');
    if (!dialog) return false;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.classList.add('ncd-dialog-open');
    return true;
  };
  document.querySelectorAll('[data-ncd-offer-open]').forEach((button) => {
    button.addEventListener('click', () => ncdOpenOfferDialog(button.dataset.ncdOfferOpen));
  });
  document.querySelectorAll('[data-ncd-offer-dialog]').forEach((dialog) => {
    const close = () => {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
      document.documentElement.classList.remove('ncd-dialog-open');
    };
    dialog.querySelectorAll('[data-ncd-offer-close]').forEach((button) => button.addEventListener('click', close));
    dialog.addEventListener('close', () => document.documentElement.classList.remove('ncd-dialog-open'));
    dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
  });
  const ncdRequestedOffer = new URLSearchParams(window.location.search).get('open_bundle');
  if (ncdRequestedOffer && ncdOpenOfferDialog(ncdRequestedOffer)) {
    const cleanUrl = new URL(window.location.href);
    cleanUrl.searchParams.delete('open_bundle');
    window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncd-lunchbox-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ncd-buy]').forEach((panel) => {
    const consents = panel.querySelectorAll('[data-ncd-consent]');
    const button = panel.querySelector('[data-ncd-purchase]');
    const variantId = panel.querySelector('input[name="id"]')?.value || '';
    const sync = () => {
      if (!button) return;
      button.disabled = !variantId || Array.from(consents).some((consent) => !consent.checked);
    };
    consents.forEach((consent) => consent.addEventListener('change', sync));
    panel.addEventListener('submit', (event) => {
      sync();
      if (!button || button.disabled) event.preventDefault();
    });
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ncd-tom2-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ncd-buy]').forEach((panel) => {
    const consents = panel.querySelectorAll('[data-ncd-consent]');
    const button = panel.querySelector('[data-ncd-purchase]');
    const variantId = panel.querySelector('input[name="id"]')?.value || '';
    const sync = () => {
      if (!button) return;
      button.disabled = !variantId || Array.from(consents).some((consent) => !consent.checked);
    };
    consents.forEach((consent) => consent.addEventListener('change', sync));
    panel.addEventListener('submit', (event) => {
      sync();
      if (!button || button.disabled) event.preventDefault();
    });
    sync();
  });

  } catch(e) { console.error(e); }
})();
})();
